import React, { useEffect } from 'react';
import styled from 'styled-components';

import { topNavHeight } from '~utils/common.utils';

// Kind of like Link but instead of routing it takes the user to a fullscreen
// view
const MobileFullscreen = ({ children, back }) => {
  // Disable scrolling body while fullscreen is active
  useEffect(() => {
    document.body.style.overflow = 'auto';
    document.body.style.height = '100vh';

    return () => {
      document.body.style.overflow = null;
      document.body.style.height = null;
    };
  });

  // Fullscreen component
  return (
    <Wrapper>
      <Content>{children}</Content>
      <BackButton onClick={back}>Takaisin</BackButton>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  top: ${topNavHeight}px;
  width: 100%;
  height: calc(100vh - ${topNavHeight}px);
  overflow: visible;

  background-color: white;
  z-index: 3;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Content = styled.div`
  overflow-y: scroll;
`;

const Button = styled.button`
  outline: none;
  border: none;
  padding: 0;
  width: 100%;
`;

const BackButton = styled(Button)`
  background-color: #848484;
  min-height: 75px;
  height: 75px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-size: 16px;
  color: white;
  cursor: pointer;
`;

export default MobileFullscreen;
